import { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';

const NAV_GROUPS = [
  {
    label: 'Master', emoji: '🗂️',
    items: [
      { to: '/admin/master/produk-po',      label: 'Produk PO' },
      { to: '/admin/master/menu-pos',       label: 'Menu POS' },
      { to: '/admin/master/menu-paket',     label: 'Menu Paket' },
      { to: '/admin/master/reward-catalog', label: 'Reward Catalog' },
      { to: '/admin/master/stok',           label: 'Stok' },
      { to: '/admin/master/pengguna',       label: 'Pengguna POS' },
      { to: '/admin/master/area',           label: 'Area' },
    ],
  },
  {
    label: 'Transaksi', emoji: '💳',
    items: [
      { to: '/admin/transaksi/kelola-po',  label: 'Kelola PO' },
      { to: '/admin/transaksi/order-po',   label: 'Order PO' },
      { to: '/admin/transaksi/order-pos',  label: 'Order POS' },
      { to: '/admin/transaksi/shift',      label: 'Shift' },
      { to: '/admin/transaksi/kas-harian', label: 'Kas Harian' },
    ],
  },
  {
    label: 'Informasi', emoji: '📊',
    items: [
      { to: '/admin/info/customers',      label: 'Customers' },
      { to: '/admin/info/kartu-stok',     label: 'Kartu Stok' },
      { to: '/admin/info/bonus-karyawan', label: 'Gaji Karyawan' },
      { to: '/admin/info/analytics',      label: 'Analytics' },
      { to: '/admin/info/referral',       label: 'Referral' },
      { to: '/admin/info/hari-libur',     label: 'Hari Libur' },
      { to: '/admin/info/settings',       label: 'Settings' },
    ],
  },
];

const BOTTOM_NAV = [
  { to: '/admin',                      label: 'Dashboard', emoji: '🏠', end: true },
  { to: '/admin/transaksi/kelola-po',  label: 'Kelola PO', emoji: '📦' },
  { to: '/admin/transaksi/order-pos',  label: 'Order POS', emoji: '🧾' },
  { to: '/admin/info/customers',       label: 'Customers', emoji: '👥' },
];

const css = `
  .admin-sidebar { overflow-y: auto; }
  .admin-sidebar::-webkit-scrollbar { width: 4px; }
  .admin-sidebar::-webkit-scrollbar-thumb { background: rgba(33,23,16,.15); border-radius: 4px; }
  @media (max-width: 768px) {
    .admin-sidebar    { display: none !important; }
    .admin-main       { padding-bottom: 72px !important; }
    .admin-bottom-nav { display: flex !important; }
  }
  @media (min-width: 769px) {
    .admin-bottom-nav { display: none !important; }
  }
  @keyframes sapanDrawerUp   { from { transform: translateY(100%); } to { transform: translateY(0); } }
  @keyframes sapanFadeIn     { from { opacity: 0; }               to { opacity: 1; } }
`;

const sideLink = ({ isActive }) => ({
  display: 'flex', alignItems: 'center',
  padding: '7px 10px', borderRadius: 6, marginBottom: 1,
  color: isActive ? 'var(--primary-hover)' : 'var(--ink-soft)',
  background: isActive ? 'var(--primary-soft)' : 'transparent',
  fontSize: '.82rem', transition: 'all .15s', textDecoration: 'none',
});

export default function AdminLayout() {
  const nav            = useNavigate();
  const location       = useLocation();
  const [open, setOpen] = useState(false);

  // Tutup saat pindah halaman
  useEffect(() => { setOpen(false); }, [location.pathname]);

  // Kunci scroll body saat drawer terbuka
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  const logout = () => {
    sessionStorage.removeItem('sapan_admin');
    nav('/admin/login');
  };

  return (
    <>
      <style>{css}</style>

      {/* ── App shell ── */}
      <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--sand)' }}>

        {/* Sidebar desktop */}
        <aside className="admin-sidebar" style={{ width: 224, background: 'var(--paper)', borderRight: '1px solid var(--line)', display: 'flex', flexDirection: 'column', flexShrink: 0, position: 'sticky', top: 0, height: '100vh' }}>
          <div style={{ padding: '20px 18px 14px', borderBottom: '1px solid var(--line)' }}>
            <div style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1.1rem', color: 'var(--ink)' }}>HAPin</div>
            <div style={{ fontFamily: "'DM Mono',monospace", fontSize: '.56rem', letterSpacing: '1.5px', textTransform: 'uppercase', color: 'var(--primary)', marginTop: 2 }}>Admin Panel</div>
          </div>
          <nav style={{ flex: 1, padding: '10px 8px', overflowY: 'auto' }}>
            <NavLink to="/admin" end style={sideLink}>Dashboard</NavLink>
            <div style={{ height: 1, background: 'var(--line)', margin: '8px 0 10px' }} />
            {NAV_GROUPS.map(g => (
              <div key={g.label} style={{ marginBottom: 16 }}>
                <div style={{ fontFamily: "'DM Mono',monospace", fontSize: '.54rem', letterSpacing: '1.8px', textTransform: 'uppercase', color: 'var(--ink-soft)', padding: '0 10px', marginBottom: 3 }}>{g.label}</div>
                {g.items.map(item => (
                  <NavLink key={item.to} to={item.to} style={sideLink}>{item.label}</NavLink>
                ))}
              </div>
            ))}
          </nav>
          <div style={{ padding: '10px 8px 18px', borderTop: '1px solid var(--line)' }}>
            <button onClick={logout} style={{ width: '100%', padding: '8px', borderRadius: 8, background: 'var(--sand)', border: '1px solid var(--line)', color: 'var(--ink-soft)', fontSize: '.78rem', cursor: 'pointer', fontFamily: 'inherit' }}>Keluar</button>
          </div>
        </aside>

        {/* Main */}
        <main className="admin-main" style={{ flex: 1, overflow: 'auto', minWidth: 0 }}>
          <Outlet />
        </main>

        {/* Bottom nav mobile */}
        <nav className="admin-bottom-nav" style={{ position: 'fixed', bottom: 0, left: 0, right: 0, background: 'var(--paper)', borderTop: '1px solid var(--line)', zIndex: 100, justifyContent: 'space-around', alignItems: 'center', padding: '6px 0 10px' }}>
          {BOTTOM_NAV.map(item => (
            <NavLink key={item.to} to={item.to} end={item.end}
              style={({ isActive }) => ({
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
                color: isActive ? 'var(--primary-hover)' : 'var(--ink-soft)',
                textDecoration: 'none', padding: '4px 8px', borderRadius: 8,
                background: isActive ? 'var(--primary-soft)' : 'transparent',
                minWidth: 52, textAlign: 'center',
              })}>
              <span style={{ fontSize: '1.15rem', lineHeight: 1 }}>{item.emoji}</span>
              <span style={{ fontSize: '.54rem', fontFamily: "'DM Mono',monospace", letterSpacing: '.3px' }}>{item.label}</span>
            </NavLink>
          ))}
          <button
            onClick={() => setOpen(true)}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, background: 'none', border: 'none', color: 'var(--ink-soft)', padding: '4px 8px', borderRadius: 8, minWidth: 52, cursor: 'pointer' }}>
            <span style={{ fontSize: '1.15rem', lineHeight: 1 }}>☰</span>
            <span style={{ fontSize: '.54rem', fontFamily: "'DM Mono',monospace", letterSpacing: '.3px' }}>Menu</span>
          </button>
        </nav>
      </div>

      {/* ── Drawer — DI LUAR flex container, langsung di Fragment ── */}
      {open && (
        <>
          {/* Overlay */}
          <div
            onClick={() => setOpen(false)}
            style={{
              position: 'fixed', inset: 0, zIndex: 300,
              background: 'rgba(0,0,0,.55)',
              animation: 'sapanFadeIn .2s ease',
            }}
          />

          {/* Panel */}
          <div style={{
            position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 301,
            background: 'var(--paper)',
            borderRadius: '20px 20px 0 0',
            maxHeight: '80vh',
            overflowY: 'auto',
            animation: 'sapanDrawerUp .25s ease',
          }}>
            {/* Handle */}
            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 12, paddingBottom: 4 }}>
              <div style={{ width: 40, height: 4, borderRadius: 2, background: 'var(--line)' }} />
            </div>

            {/* Brand */}
            <div style={{ padding: '8px 20px 12px', borderBottom: '1px solid var(--line)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1rem', color: 'var(--ink)' }}>HAPin</div>
                <div style={{ fontFamily: "'DM Mono',monospace", fontSize: '.54rem', letterSpacing: '1.5px', textTransform: 'uppercase', color: 'var(--primary)', marginTop: 1 }}>Admin Panel</div>
              </div>
              <button onClick={() => setOpen(false)} style={{ background: 'var(--sand)', border: 'none', borderRadius: 8, color: 'var(--ink-soft)', padding: '6px 12px', cursor: 'pointer', fontSize: '.8rem' }}>✕</button>
            </div>

            {/* Dashboard */}
            <div style={{ padding: '10px 16px 0' }}>
              <NavLink to="/admin" end style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '10px 14px', borderRadius: 10, marginBottom: 6,
                background: isActive ? 'var(--primary-soft)' : 'var(--sand)',
                color: isActive ? 'var(--primary-hover)' : 'var(--ink-soft)',
                textDecoration: 'none', fontSize: '.88rem', fontWeight: isActive ? 600 : 400,
                border: isActive ? '1px solid rgba(227,91,42,.25)' : '1px solid transparent',
              })}>
                <span>🏠</span> Dashboard
              </NavLink>
            </div>

            {/* Groups */}
            <div style={{ padding: '0 16px 8px' }}>
              {NAV_GROUPS.map(g => (
                <div key={g.label} style={{ marginBottom: 10 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 2px 6px', fontFamily: "'DM Mono',monospace", fontSize: '.58rem', letterSpacing: '1.8px', textTransform: 'uppercase', color: 'var(--ink-soft)' }}>
                    <span>{g.emoji}</span>{g.label}
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
                    {g.items.map(item => (
                      <NavLink key={item.to} to={item.to} style={({ isActive }) => ({
                        padding: '10px 12px', borderRadius: 10,
                        background: isActive ? 'var(--primary-soft)' : 'var(--sand)',
                        color: isActive ? 'var(--primary-hover)' : 'var(--ink-soft)',
                        textDecoration: 'none', fontSize: '.82rem', fontWeight: isActive ? 600 : 400,
                        border: isActive ? '1px solid rgba(227,91,42,.3)' : '1px solid transparent',
                      })}>
                        {item.label}
                      </NavLink>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Logout */}
            <div style={{ padding: '8px 16px 20px' }}>
              <button onClick={logout} style={{ width: '100%', padding: '11px', borderRadius: 10, background: '#FDEBE5', border: '1px solid rgba(220,38,38,.2)', color: '#B23A15', fontSize: '.84rem', cursor: 'pointer', fontFamily: 'inherit' }}>
                Keluar
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
